import {
  ENGLISH_USA,
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  POLISH,
  PORTUGUESE,
  SPANISH,
  SWEDISH,
} from 'config/types/language';

import {
  SHORTLINK_CODE_LANDING_PAGE_DEU,
  SHORTLINK_CODE_LANDING_PAGE_ENG,
  SHORTLINK_CODE_LANDING_PAGE_FRA,
  SHORTLINK_CODE_LANDING_PAGE_ITA,
  SHORTLINK_CODE_LANDING_PAGE_POL,
  SHORTLINK_CODE_LANDING_PAGE_POR,
  SHORTLINK_CODE_LANDING_PAGE_SPA,
  SHORTLINK_CODE_LANDING_PAGE_SWE,
  SHORTLINK_CODE_LANDING_PAGE_USA,

  SHORTLINK_CODE_HEADER_CTA_DEU,
  SHORTLINK_CODE_HEADER_CTA_ENG,
  SHORTLINK_CODE_HEADER_CTA_FRA,
  SHORTLINK_CODE_HEADER_CTA_ITA,
  SHORTLINK_CODE_HEADER_CTA_POL,
  SHORTLINK_CODE_HEADER_CTA_POR,
  SHORTLINK_CODE_HEADER_CTA_SPA,
  SHORTLINK_CODE_HEADER_CTA_SWE,
  SHORTLINK_CODE_HEADER_CTA_USA,
} from 'config/shortlinkCodes';

export const getFacebookLocale = (languageCode) => {
  switch (languageCode) {
    case FRENCH: return 'fr_FR';
    case GERMAN: return 'de_DE';
    case ITALIAN: return 'it_IT';
    case POLISH: return 'pl_PL';
    case PORTUGUESE: return 'pt_BR';
    case SPANISH: return 'es_ES';
    case SWEDISH: return 'sv_SE';

    case ENGLISH:
    case ENGLISH_USA:
    default:
      return 'en_US';
  }
};

export const getFacebookPageIDs = (languageCode) => {
  switch (languageCode) {
    case FRENCH: return ['730630120408466'];
    case GERMAN: return ['522040488002422'];
    case ITALIAN: return ['315019868861144'];
    case PORTUGUESE: return ['347605872246588'];
    case SPANISH: return ['1576231026019053'];

    case POLISH:
    case SWEDISH:
      return ['23820609833'];

    case ENGLISH_USA:
    case ENGLISH:
    default:
      return ['23820609833', '1272562162872574'];
  }
};

export const getLandingPageShortcode = (languageCode) => {
  switch (languageCode) {
    case ENGLISH_USA: return SHORTLINK_CODE_LANDING_PAGE_USA;
    case FRENCH: return SHORTLINK_CODE_LANDING_PAGE_FRA;
    case GERMAN: return SHORTLINK_CODE_LANDING_PAGE_DEU;
    case ITALIAN: return SHORTLINK_CODE_LANDING_PAGE_ITA;
    case POLISH: return SHORTLINK_CODE_LANDING_PAGE_POL;
    case PORTUGUESE: return SHORTLINK_CODE_LANDING_PAGE_POR;
    case SPANISH: return SHORTLINK_CODE_LANDING_PAGE_SPA;
    case SWEDISH: return SHORTLINK_CODE_LANDING_PAGE_SWE;

    case ENGLISH:
    default:
      return SHORTLINK_CODE_LANDING_PAGE_ENG;
  }
};

export const getCTAShortcode = (languageCode) => {
  switch (languageCode) {
    case ENGLISH_USA: return SHORTLINK_CODE_HEADER_CTA_USA;
    case FRENCH: return SHORTLINK_CODE_HEADER_CTA_FRA;
    case GERMAN: return SHORTLINK_CODE_HEADER_CTA_DEU;
    case ITALIAN: return SHORTLINK_CODE_HEADER_CTA_ITA;
    case POLISH: return SHORTLINK_CODE_HEADER_CTA_POL;
    case PORTUGUESE: return SHORTLINK_CODE_HEADER_CTA_POR;
    case SPANISH: return SHORTLINK_CODE_HEADER_CTA_SPA;
    case SWEDISH: return SHORTLINK_CODE_HEADER_CTA_SWE;

    case ENGLISH:
    default:
      return SHORTLINK_CODE_HEADER_CTA_ENG;
  }
};

export const getMetaImageDimensions = (metaList) => {
  const imageMeta = metaList.find((meta) => 'name' in meta && 'og:image' === meta.name);
  if (!imageMeta || !imageMeta.content) {
    return null;
  }

  const dimensions = imageMeta.content.match(/resize=(\d+),(\d+)/);
  if (!dimensions[1] || !dimensions[2]) {
    return null;
  }

  return {
    height: dimensions[2],
    width: dimensions[1],
  };
};
